<div class="dashboard-page">
  <section class="kpi-group" *ngFor="let group of dashboardKpiGroups" [ngClass]="'kpi-group--' + group.tone" [hidden]="!group.items.length">
    <header class="kpi-group__header">
      <h2>{{ group.title | traduccion }}</h2>
    </header>

    <div class="kpis-grid">
      <app-kpi-card
        *ngFor="let kpi of group.items"
        [title]="kpi.title"
        [value]="kpi.value"
        [icon]="kpi.icon"
        [iconColor]="kpi.iconColor">
      </app-kpi-card>
    </div>
  </section>

  <section class="charts-shell" *ngIf="dashboardCharts.length">
    <div class="charts-grid">
    <app-chart-card
      *ngFor="let chart of dashboardCharts"
      [title]="chart.title"
      [subtitle]="chart.subtitle || undefined"
      [footer]="chart.footer || undefined"
      [type]="chart.type"
      [labels]="chart.labels"
      [datasets]="chart.datasets">
    </app-chart-card>
    </div>
  </section>
</div>
